import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import StyledProductPart from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Components/ProductPart';

const useStyles = makeStyles(
    {
        disabled: {
            pointerEvents: 'none',
            opacity: 0.4,
        },
    },
    { name: 'DisabledProductPart' }
);

const ignoreSelect = () => {};

const ProductPart = ({ onSelect, ...props }) => {
    const classes = useStyles();
    const disabled = Boolean(props.optionclassification.disable);

    // the part is a focusable button, so ignoring the selection also blocks keyboard users
    return (
        <StyledProductPart
            {...props}
            onSelect={disabled ? ignoreSelect : onSelect}
            classes={disabled ? { root: classes.disabled } : undefined}
        />
    );
};

ProductPart.propTypes = {
    onSelect: PropTypes.func,
    optionclassification: PropTypes.object.isRequired,
};

export default ProductPart;
